import { TYPE_SERVER_SUBDOMAIN } from "environments/environment-domain";
import { INGXLoggerConfig } from "ngx-logger";

export type AngularEnvironment = {
  production: boolean;
  DOMAIN: string;
  API_URL: string;
  // Some options of the LoggerConfig work differently with our setup, because of our custom logger monitor:
  // - 'disableConsoleLogging' overwritten on runtime, to prevent double logging to the console.
  // - 'disableFileDetails' ignored.
  logger: INGXLoggerConfig;
  testToolEnable: boolean;
  keycloakConfig: {
    url: string;
    realm: string;
  };
};

// Utility function to check if any subdomain parts are present in the URL
export function isTestToolEnabledByDomain(): boolean {
  const url: URL = new URL(window.location.href);
  const hostname: string = url.hostname;
  const subdomain: string = hostname.split(".")[0]; // Extract the subdomain part

  return TYPE_SERVER_SUBDOMAIN.includes(subdomain);
}
